import { Box, Button } from 'shared/ui'

export const SectionButtons = ({
  isLoading,
  onSave,
  onCancel,
  isDisabled,
}: {
  isLoading: boolean
  isDisabled?: boolean
  onSave: () => void
  onCancel: () => void
}) => {
  return (
    <Box display={'flex'} gap={'8px'}>
      <Button
        text={'Save'}
        contained={'primary'}
        size={'medium'}
        onClick={onSave}
        disabled={isDisabled || isLoading}
        loading={isLoading}
      />
      <Button
        text={'Cancel'}
        contained={'secondary'}
        size={'medium'}
        onClick={onCancel}
        disabled={isDisabled || isLoading}
      />
    </Box>
  )
}
